import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function RegistrationLoginModal({
    show,
    onClose,
    onRegister,
    onLogin,
    navigateToPath = "/questions/step2_1" // Default path as requested
}) {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

    useEffect(() => {
        // If the modal is supposed to show, auth is not loading, and user is authenticated
        if (show && !isAuthLoading && isAuthenticated) {
            navigate(navigateToPath);
            if (onClose) { // Signal parent to hide the modal
                onClose();
            }
        }
    }, [show, isAuthenticated, isAuthLoading, navigate, navigateToPath, onClose]);

    if (!show || (isAuthenticated && !isAuthLoading)) {
        return null;
    }

    return (
        <>
            <div className="modal fade show" style={{ display: 'block' }} id="registrationModal" tabIndex="-1" aria-labelledby="registrationModalLabel" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content p-3">
                        <div className="modal-header border-bottom-0">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body text-center px-5">
                            <h3 className="mb-3">¡Muchas gracias!</h3>
                            <p>Para seguir armando el viaje de tus sueños, necesitamos que te registres o inicies sesión en nuestra plataforma.</p>
                        </div>
                        <div className="modal-footer justify-content-center border-top-0">
                            <button type="button" className="btn btn-outline-checkin m-3" style={{ minWidth: '150px' }} onClick={onRegister}>
                                Registrarme
                            </button>
                            <button type="button" className="btn btn-checkin m-3" style={{ minWidth: '150px' }} onClick={onLogin}>
                                Iniciar sesión
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default RegistrationLoginModal;
